import type { TRouteWithoutRedirect } from "@sphtech/web2-core/ssr";
import { ResponseType } from "@sphtech/web2-core/ssr";
import fetchCaas from "@src/app/components/helper/fetchCaas";
import fetchTMApi from "@src/app/components/helper/fetchTMApi";
import { UrlMatch } from "@src/app/data";
import { getOsBySection } from "@src/app/query/query";
import { MoreArticlesRequstData } from "@src/app/types/MoreArticlesApi";
import { OSResponse, PartialCueArticle } from "@src/app/types/Opensearch";
import getOSProcessedArticleData, {
  type ProcessedArticleData,
} from "@transformer/useOsResponse";

function removeTrailingSlash(s: string): string {
  return s.endsWith("/") ? s.substring(0, s.length - 1) : s;
}

function removeLeadingSlash(s: string): string {
  return s.startsWith("/") ? s.slice(1) : s;
}

export const fetchPhotoGalleryData = async ({
  urlComponent,
}: UrlMatch): Promise<
  TRouteWithoutRedirect<ProcessedArticleData[], string>
> => {
  const section = removeLeadingSlash(removeTrailingSlash(urlComponent.path));

  try {
    const SectionList = (await fetchCaas({
      searchQuery: getOsBySection(section, 7),
    })) as OSResponse<PartialCueArticle>;

    const hits = SectionList.payload.hits.total.value;
    if (hits === 0) {
      return { type: ResponseType.CLIENT_ERROR, statusCode: 404 };
    }

    return {
      type: ResponseType.SUCCESS,
      statusCode: 200,
      payload: getOSProcessedArticleData(SectionList),
    };
  } catch (e) {
    const error = e as Error;
    return {
      type: ResponseType.SERVER_ERROR,
      statusCode: 500,
      payload: error.message,
    };
  }
};

export async function fetchMoreStoriesData(
  requestData: MoreArticlesRequstData,
): Promise<ProcessedArticleData[] | []> {
  try {
    const response: ProcessedArticleData[] = await fetchTMApi(
      "more-section-stories",
      "POST",
      {
        section: requestData.filterArticlesBasedOn,
        sort: requestData.sort,
        size: 7,
      },
    );

    return response;
  } catch (error) {
    return [];
  }
}
